export default {
  props: {
    layout: {
      type: String,
      default: "default",
    },
    task: {
      type: [Object, Boolean],
      default: false,
    },
  },
  emits: ["userTask:taskHandingStarted", "userTask:taskHandingComplete"],
  data: function () {
    return {};
  },
  computed: {},
  methods: {
    async standardStartTaskHandling() {
      this.$emit("userTask:taskHandingStarted", { task: this.task });
    },
    async standardCompleteTaskHandling() {
      if (!this.asyncOps) {
        let { default: asyncOperations } = await import(
          "@/client/extensions/composition/asyncOperations.js"
        );
        this.asyncOps = asyncOperations(this.$props, this.$store, {});
      }

      let url = `entity/userTask/${this.task.id}`;
      let data = { isComplete: true };
      let callResult = await this.asyncOps.patch(url, data);

      if ( callResult.hasError) {
        warn('userTaskItem: error reporting completion', {callResult, task:this.task})
      }
      this.$emit("userTask:taskHandingComplete", { task: this.task });
    },
  },
  created() {},
};
